import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CLOSE_WINDOW, PRIVACY_LEAFLET_MORE_INFO, PRIVACY_LEAFLET_ONE_LINER } from 'mk/autogenerated/translations/PrivacyReminder.135e6dfddf58cfcf76e5103fd715e1bf'
import { aboutPrivacyAndCookiePolicyUrl } from 'mk2/apps/about/urls';
import Link from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './PrivacyReminder.mscss';

interface OwnProps {
    currentUrl: string;
    showPrivacyReminder: boolean;
    onPrivacyLeafletAccept();
}

class PrivacyReminder extends React.PureComponent<OwnProps> {

    public componentDidMount() {
        if (this.props.showPrivacyReminder) {
            document.body.classList.add('has-privacy-reminder');
        }
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.showPrivacyReminder !== this.props.showPrivacyReminder) {
            if (this.props.showPrivacyReminder) {
                document.body.classList.add('has-privacy-reminder');
            } else {
                document.body.classList.remove('has-privacy-reminder');
            }
        }
    }

    public componentWillUnmount() {
        document.body.classList.remove('has-privacy-reminder');
    }

    public render() {
        const {
            currentUrl, showPrivacyReminder, onPrivacyLeafletAccept,
        } = this.props;

        return showPrivacyReminder ? (
            <div className={styles.PrivacyReminder}>
                <div className={styles.PrivacyReminder__inside}>
                    <div className={styles.PrivacyReminder__inside__leftDiv}>
                        {PRIVACY_LEAFLET_ONE_LINER}
                        &nbsp;
                        <Link
                            to={url(aboutPrivacyAndCookiePolicyUrl, {}, {next: encodeURIComponent(currentUrl)})}
                            rel="nofollow"
                        >
                            {PRIVACY_LEAFLET_MORE_INFO}
                        </Link>
                    </div>
                    <div className={styles.PrivacyReminder__inside__rightDiv} onClick={onPrivacyLeafletAccept}>
                        {CLOSE_WINDOW}
                        <FontAwesomeIcon icon={faTimes} className={styles.PrivacyReminder__inside__rightDiv__icon} />
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default PrivacyReminder;
